import { PaymentDataRequest } from './payment-data-request.model';

class PaymentInfo extends PaymentDataRequest {
    policyPeriodId: string;
}

export class SetPaymentDataRequest {
    paymentInfo: PaymentInfo;
    paymentFee: number;
    setPaymentDataAndQuote: boolean;
}
